// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.P64OxQLzwnU3ql_Z22bi .Lt8alrUebAVLIdJbBZ5v {
    transition: opacity 0.3s ease-in-out;
}

.L9BwsX4ekwbqCyoj5tvW {
    transition: transform 0.3s ease-in-out;
}

.yrJed6Cvz6XME1ZKiwpE {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.85);
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: YWOh2bJDOmD8wp1N3iLb 0.3s ease-in-out;
    padding: 1rem;
}

@keyframes YWOh2bJDOmD8wp1N3iLb {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.sCtK93oPO0UOfWoxaujw {
    background-color: white;
    padding: 2rem;
    border-radius: 0.5rem;
    max-width: 675px;
}

.sCtK93oPO0UOfWoxaujw h2 {
    margin: 0 0 0.5rem;
}

.sCtK93oPO0UOfWoxaujw form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
}

.sCtK93oPO0UOfWoxaujw label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.w2Lj0Lvw9DzJcgz4o5M8 {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
}

.w2Lj0Lvw9DzJcgz4o5M8 label {
    width: 50%;
}

.ZK6oSItZcWSr5kWrCF2M,
.N1V65VPIOd25BAy_hZJv {
    max-width: 25rem;
}

.ZK6oSItZcWSr5kWrCF2M {
    margin-bottom: 1rem;
}

.sCtK93oPO0UOfWoxaujw button {
    width: 100%;
}

.N1V65VPIOd25BAy_hZJv {
    font-size: 0.75rem;
}

.P64OxQLzwnU3ql_Z22bi .eTOOClJpYbbYdb2zzSIg {
    transition: transform 0.3s ease-in-out;
}

.P64OxQLzwnU3ql_Z22bi:hover .eTOOClJpYbbYdb2zzSIg {
    transform: translateX(0.5rem);
}

.P64OxQLzwnU3ql_Z22bi:disabled {
    opacity: 0.75;
}

.P64OxQLzwnU3ql_Z22bi {
    margin-top: 1rem;
}

.dTBBYIum1J1PEyXpPdyA {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.dTBBYIum1J1PEyXpPdyA button {
    margin: 0;
}

.dTBBYIum1J1PEyXpPdyA button,
.dTBBYIum1J1PEyXpPdyA button span {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);
}

@media screen and (max-width: 768px) {
    .sCtK93oPO0UOfWoxaujw {
        width: 100%;
        max-height: 90vh;
        overflow-y: scroll;
    }

    .w2Lj0Lvw9DzJcgz4o5M8 {
        flex-wrap: wrap;
    }

    .w2Lj0Lvw9DzJcgz4o5M8 > label {
        width: 100%;
    }

    .ZK6oSItZcWSr5kWrCF2M {
        font-size: 0.75rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/CallBack/CallBack.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gDAAkC;IAClC,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".button .text {\n    transition: opacity 0.3s ease-in-out;\n}\n\n.icon {\n    transition: transform 0.3s ease-in-out;\n}\n\n.background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    background-color: rgba(0, 0, 0, 0.85);\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    animation: fadeIn 0.3s ease-in-out;\n    padding: 1rem;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.modal {\n    background-color: white;\n    padding: 2rem;\n    border-radius: 0.5rem;\n    max-width: 675px;\n}\n\n.modal h2 {\n    margin: 0 0 0.5rem;\n}\n\n.modal form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.modal label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    width: 100%;\n}\n\n.row label {\n    width: 50%;\n}\n\n.description,\n.legal {\n    max-width: 25rem;\n}\n\n.description {\n    margin-bottom: 1rem;\n}\n\n.modal button {\n    width: 100%;\n}\n\n.legal {\n    font-size: 0.75rem;\n}\n\n.button .arrow {\n    transition: transform 0.3s ease-in-out;\n}\n\n.button:hover .arrow {\n    transform: translateX(0.5rem);\n}\n\n.button:disabled {\n    opacity: 0.75;\n}\n\n.button {\n    margin-top: 1rem;\n}\n\n.button-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.button-group button {\n    margin: 0;\n}\n\n.button-group button,\n.button-group button span {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);\n}\n\n@media screen and (max-width: 768px) {\n    .modal {\n        width: 100%;\n        max-height: 90vh;\n        overflow-y: scroll;\n    }\n\n    .row {\n        flex-wrap: wrap;\n    }\n\n    .row > label {\n        width: 100%;\n    }\n\n    .description {\n        font-size: 0.75rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `P64OxQLzwnU3ql_Z22bi`,
	"text": `Lt8alrUebAVLIdJbBZ5v`,
	"icon": `L9BwsX4ekwbqCyoj5tvW`,
	"background": `yrJed6Cvz6XME1ZKiwpE`,
	"fadeIn": `YWOh2bJDOmD8wp1N3iLb`,
	"modal": `sCtK93oPO0UOfWoxaujw`,
	"row": `w2Lj0Lvw9DzJcgz4o5M8`,
	"description": `ZK6oSItZcWSr5kWrCF2M`,
	"legal": `N1V65VPIOd25BAy_hZJv`,
	"arrow": `eTOOClJpYbbYdb2zzSIg`,
	"button-group": `dTBBYIum1J1PEyXpPdyA`
};
export default ___CSS_LOADER_EXPORT___;
